/*BUILT
import DivisionBoard from './DivisionBoard/DivisionBoard'
import PegBoard from './PegBoard/PegBoard';
import GoldenBeads from './Golden Beads/GoldenBeads';
import BeadStair from './BeadStair/BeadStair';
import MultiplicationBoard from './MultiplicationBoard/MultiplicationBoard';
import SnakeGame from './SubtractionSnakeGame/SnakeGame';
import SnakeGame from './AdditionSnakeGame/SnakeGame';
import SnakeGame from './ElementaryNegativeSnakeGame/SnakeGame';
import LargeBeadFrame from './LargeBeadFrame/LargeBeadFrame';
import SmallBeadFrame from './SmallBeadFrame/SmallBeadFrame';
import GoldenBeadFrame from './GoldenBeadFrame/GoldenBeadFrame';
import MovableAlphabet from './LCC/MovableAlphabet';
import MovableAlphabet from './LCP/MovableAlphabet';
import MovableAlphabet from './UCC/MovableAlphabet';
import MovableAlphabet from './UCP/MovableAlphabet';
import CheckerBoard from './CheckerBoard/CheckerBoard';
import FractionCabinet from './FractionCabinet/FractionCabinet';
import PuzzleMaps from './PuzzleMaps/PuzzleMaps';
import MultiBase from './MultiBase/MultiBase';
import CutoutFractions from './CutoutFractions/CutoutFractions';
import BeadBars from './BeadBars/BeadBars';
import BeadBars from './SubtractionStripboard/Stripboard';
import BeadBars from './AdditionStripboard/Stripboard';

BUGS
import GrammarBoxes from './GrammarBoxes/GrammarBoxes';


WORKING
import PinkSeries from './PinkSeries/PinkSeries';



^MORE MATERIALS*/
import CardsandCounters from './CardsandCounters/CardsandCounters';

import './App.css';
function App() {
  return (
    <div className="App">
      <CardsandCounters  />
    </div>
  );
}
export default App;